import React, { useEffect, useState } from 'react';
import { subscribeProcessing } from '../lib/processing';

/** Full-app overlay for saves, updates, imports, and other backend work. */
export function GlobalProcessing() {
  const [state, setState] = useState<{ count: number; label: string | null }>({
    count: 0,
    label: null,
  });

  useEffect(() => subscribeProcessing(setState), []);

  if (state.count <= 0) return null;

  return (
    <div
      className="fixed inset-0 z-[200] flex items-center justify-center bg-ink-950/45 backdrop-blur-[1px]"
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label={state.label || 'Processing'}
    >
      <div className="flex min-w-[14rem] items-center gap-3 border-2 border-ink-900 bg-white px-5 py-4 shadow-xl">
        <span
          className="inline-block h-5 w-5 animate-spin rounded-full border-2 border-ink-200 border-t-ink-900"
          aria-hidden
        />
        <div>
          <p className="font-display text-sm font-bold uppercase tracking-wide text-ink-950">
            {state.label || 'Processing…'}
          </p>
          <p className="text-xs text-ink-600">Please wait — talking to the server</p>
        </div>
      </div>
    </div>
  );
}
